export enum TemplateActionType {
    EditVersion = 1,
    EditNotes = 2,
    DeleteTemplate = 3,
    EditName = 4,
}
